import { render, staticRenderFns } from "./chargeCard-list.vue?vue&type=template&id=963158bc&scoped=true&"
import script from "./chargeCard-list.vue?vue&type=script&lang=js&"
export * from "./chargeCard-list.vue?vue&type=script&lang=js&"
import style0 from "./chargeCard-list.vue?vue&type=style&index=0&id=963158bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963158bc",
  null
  
)

export default component.exports